<div class="opportunity pt-0">
  <div id="work-order" class="d-flex align-items-center justify-content-between">
    <h3 class="heading mb-0 mt-2">Work Order</h3>
    <div *ngIf="preview" class="d-flex align-items-center">
      <button *ngIf="!review" class="btn base-btn estimate-btn" [disabled]="!(orders && orders.length)"
        (click)="reviewWorkOrder()">Review Work Order</button>
      <button *ngIf="review" class="btn base-btn estimate-btn" (click)="callApi()">Download</button>
    </div>
  </div>
  <div id="work-order-list" class="opportunity-list">
    <div *ngIf="orders && orders.length; else noDataFound" class="table-responsive scroll-hide">
      <table class="table">
        <thead class="p-2">
          <tr>
            <th scope="col" style="width: 48px;">Item</th>
            <th scope="col" style="width: 58px;">Image</th>
            <th scope="col">Item Name</th>
            <th scope="col">Description</th>
            <th scope="col">Video</th>
            <th scope="col">Charge Type</th>
            <th scope="col" *ngIf="hidePrice && !lumpSum">Price</th>
            <th scope="col" *ngIf="hidePrice && !lumpSum">Disc(-)</th>
            <th scope="col" *ngIf="hidePrice && !lumpSum">Tax</th>
            <th scope="col" *ngIf="hidePrice && !lumpSum">Qty</th>
            <th scope="col" *ngIf="hidePrice && !lumpSum">Total</th>
            <th scope="col">Complete</th>
            <th scope="col">Completed By</th>
            <th scope="col">Date</th>
            <th scope="col">Status</th>
            <!-- <th scope="col">Completed</th> -->
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let order of orders;let i=index">
            <ng-container *ngIf="order?.isBundle else RegularOrders">
              <!-- Bundle header row -->
              <tr class="bundle-header-row handIcon" (click)="toggleBundle(order.bundleInstanceId)"
                (click)="viewOrder(order)">
                <td class="srno">{{i+1}}</td>
                <td (click)="order?.images?.length && showImages(order.itemImage)">
                  <div *ngIf="order?.images?.length >1 ; else showSingleImage" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (order.images.length-1)}}</span>
                    <div class="image">
                      <img [src]="order?.images[0].link" width="28px" height="28px" class="rounded-circle">
                    </div>
                  </div>
                  <ng-template #showSingleImage>
                    <img *ngIf="order?.images?.length else noMedia" [src]="order?.images[0]?.link" width="28px"
                      height="28px" class="rounded-circle">
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <td class="description" [ngClass]="{'greyed-out-text': order?.quantity === 0}"><span
                    [matTooltip]="order['itemName']"> {{ order['itemName'].length >
                    25 ? order['itemName'].slice(0, 25) + '...' :
                    order['itemName'] }}</span></td>
                <td class="description">
                  <div>{{order['description']||'---'}}</div>
                </td>
                <td (click)="order.videos?.length && showImages(order.itemImage)">
                  <div *ngIf="order.videos?.length >1 ; else showSingleVideo" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (order.videos.length-1)}}</span>
                    <div class="image">
                      <video [src]="order.videos[0].link" width="28px" height="28px" class="rounded-circle"></video>
                    </div>
                  </div>
                  <ng-template #showSingleVideo>
                    <video *ngIf="order.videos?.length else noMedia" [src]="order.videos[0].link" width="28px"
                      height="28px" class="rounded-circle"></video>
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>

                <td>{{order['chargeType'] || '---'}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{'$'+(order['price'] || 0 ).toFixed(2) }}</td>
                <!-- Disc(-) — bundle discount sits on the bundle row -->
                <td *ngIf="hidePrice && !lumpSum">{{'$' + woDiscount(order).toFixed(2)}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{'$' + woTax(order).toFixed(2)}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{order['quantity']}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{'$' + woTotal(order).toFixed(2)}}</td>
                <td>{{order?.completeInfo?.completeStatus == 1 ? '---' : order?.completeInfo?.completeStatus == 3 ?
                  'Not Going to do' : 'Complete'}}</td>
                <td>{{order?.completedByName || '---'}}</td>
                <td>{{(order?.completeInfo?.completedAt | date: 'dd MMM, yyyy') ||'---'}}</td>
                <td class="">
                  <span class="btn w-100" [ngClass]="page === 'opp'? 'green-btn': setStatusStyle(order?.status)">
                    {{page==='opp'? 'Approved' : (order['status'] === 'Not_Started' ? 'Not Started' :
                    order?.status)}}</span>
                </td>
              </tr>

              <!-- Bundle child item rows (accordion) -->
              <ng-container *ngIf="isBundleExpanded(order.bundleInstanceId)">
                <tr *ngFor="let childItem of order.childItems; let ci = index" (click)="viewOrder(order)"
                  class="bundle-child-row handIcon example-box">
                  <td class="srno" [ngClass]="{'greyed-out-text': childItem?.quantity === 0}"></td>
                  <td (click)="childItem?.images?.length && showImages(childItem.itemImage)">
                    <div *ngIf="childItem?.images?.length >1 ; else showSingleImage" class="more-images ">
                      <span class="rounded-circle">{{'+'+ (childItem.images.length-1)}}</span>
                      <div class="image">
                        <img [src]="childItem?.images[0].link" width="28px" height="28px" class="rounded-circle">
                      </div>
                    </div>
                    <ng-template #showSingleImage>
                      <img *ngIf="childItem?.images?.length else noMedia" [src]="childItem?.images[0]?.link"
                        width="28px" height="28px" class="rounded-circle">
                      <ng-template #noMedia>
                        <div>---</div>
                      </ng-template>
                    </ng-template>
                  </td>
                  <td class="description" [ngClass]="{'greyed-out-text': childItem?.quantity === 0}"><span
                      [matTooltip]="childItem['itemName']"> {{ childItem['itemName'].length >
                      25 ? childItem['itemName'].slice(0, 25) + '...' :
                      childItem['itemName'] }}</span></td>
                  <td class="description">
                    <div>{{order['description']||'---'}}</div>
                  </td>
                  <td (click)="childItem.videos?.length && showImages(childItem.itemImage)">
                    <div *ngIf="childItem.videos?.length >1 ; else showSingleVideo" class="more-images ">
                      <span class="rounded-circle">{{'+'+ (childItem.videos.length-1)}}</span>
                      <div class="image">
                        <video [src]="childItem.videos[0].link" width="28px" height="28px"
                          class="rounded-circle"></video>
                      </div>
                    </div>
                    <ng-template #showSingleVideo>
                      <video *ngIf="childItem.videos?.length else noMedia" [src]="childItem.videos[0].link" width="28px"
                        height="28px" class="rounded-circle"></video>
                      <ng-template #noMedia>
                        <div>---</div>
                      </ng-template>
                    </ng-template>
                  </td>

                  <td>{{childItem['chargeType'] || '---'}}</td>
                  <td *ngIf="hidePrice && !lumpSum">{{'$'+(childItem['price'] || 0 ).toFixed(2) }}</td>
                  <!-- Disc(-) — bundle discount is shown on the bundle row -->
                  <td *ngIf="hidePrice && !lumpSum">---</td>
                  <td *ngIf="hidePrice && !lumpSum">{{'$'+(childItem['tax'] || '0.00' )}}</td>
                  <td *ngIf="hidePrice && !lumpSum">{{childItem['quantity']}}</td>
                  <td *ngIf="hidePrice && !lumpSum">{{'$'+(childItem['total'] || 0).toFixed(2)}}</td>
                  <td>{{childItem?.completeInfo?.completeStatus == 1 ? '---' : childItem?.completeInfo?.completeStatus == 3
                    ? 'Not Going to do' : 'Complete'}}</td>
                  <td>{{childItem?.completedByName || '---'}}</td>
                  <td>{{(childItem?.completeInfo?.completedAt | date: 'dd MMM, yyyy') ||'---'}}</td>
                  <td class="">
                    <span class="btn w-100" [ngClass]="page === 'opp'? 'green-btn': setStatusStyle(childItem?.status)">
                      {{page==='opp'? 'Approved' : (childItem['status'] === 'Not_Started' ? 'Not Started' :
                      childItem?.status)}}</span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #RegularOrders>
              <tr (click)="viewOrder(order)">
                <td class="srno">{{i+1}}</td>
                <td (click)="order?.images?.length && showImages(order.itemImage)">
                  <div *ngIf="order?.images?.length >1 ; else showSingleImage" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (order.images.length-1)}}</span>
                    <div class="image">
                      <img [src]="order?.images[0].link" width="28px" height="28px" class="rounded-circle">
                    </div>
                  </div>
                  <ng-template #showSingleImage>
                    <img *ngIf="order?.images?.length else noMedia" [src]="order?.images[0]?.link" width="28px"
                      height="28px" class="rounded-circle">
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <td class="description" [ngClass]="{'greyed-out-text': order?.quantity === 0}"><span
                    [matTooltip]="order['itemName']"> {{ order['itemName'].length >
                    25 ? order['itemName'].slice(0, 25) + '...' :
                    order['itemName'] }}</span></td>
                <td class="description">
                  <div>{{order['description']||'---'}}</div>
                </td>
                <td (click)="order.videos?.length && showImages(order.itemImage)">
                  <div *ngIf="order.videos?.length >1 ; else showSingleVideo" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (order.videos.length-1)}}</span>
                    <div class="image">
                      <video [src]="order.videos[0].link" width="28px" height="28px" class="rounded-circle"></video>
                    </div>
                  </div>
                  <ng-template #showSingleVideo>
                    <video *ngIf="order.videos?.length else noMedia" [src]="order.videos[0].link" width="28px"
                      height="28px" class="rounded-circle"></video>
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>

                <td>{{order['chargeType'] || '---'}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{'$'+(order['price'] || 0 ).toFixed(2) }}</td>
                <!-- Disc(-) -->
                <td *ngIf="hidePrice && !lumpSum">{{'$' + woDiscount(order).toFixed(2)}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{'$' + woTax(order).toFixed(2)}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{order['quantity']}}</td>
                <td *ngIf="hidePrice && !lumpSum">{{'$' + woTotal(order).toFixed(2)}}</td>
                <td>{{order?.completeInfo?.completeStatus == 1 ? '---' : order?.completeInfo?.completeStatus == 3 ?
                  'Not Going to do' : 'Complete'}}</td>
                <td>{{order?.completedByName || '---'}}</td>
                <td>{{(order?.completeInfo?.completedAt | date: 'dd MMM, yyyy') ||'---'}}</td>
                <td class="">
                  <span class="btn w-100" [ngClass]="page === 'opp'? 'green-btn': setStatusStyle(order?.status)">
                    {{page==='opp'? 'Approved' : (order['status'] === 'Not_Started' ? 'Not Started' :
                    order?.status)}}</span>
                </td>
              </tr>
            </ng-template>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div *ngIf="(orders && orders?.length) && (hidePrice || lumpSum)" class="w-100">
      <hr class="dashed-line" />
      <div class="py-3 d-flex flex-column align-items-end">
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-heading pb-0 mb-2">SubTotal:</h3>
          <span class="amount-heading">{{'$'+ formatText(subtotalBeforeDiscount,2)}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center amount text-success" *ngIf="discountAmount > 0">
          <h3 class="amount-breakup pb-0 mb-2 text-success">Discount:</h3>
          <span class="amount-breakup text-success">{{'-$'+ discountAmount.toFixed(2)}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-breakup pb-0 mb-2">Tax:</h3>
          <!-- With a discount, use the same source as SubTotal/Total so the summary always adds up -->
          <span class="amount-breakup">{{'$'+ formatText(discountAmount > 0 ? taxAmount : totalTaxAmount,2)}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-breakup pb-0 mb-2">Total:</h3>
          <span class="amount-breakup">{{'$'+ formatText(grandTotal,2)}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-breakup pb-0 mb-2">Total Payments:</h3>
          <span class="amount-breakup">{{'$'+ formatText(details?.totalAmountPaid,2)}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-breakup pb-0 mb-2">Balance Remaining:</h3>
          <span class="amount-breakup">{{'$'+ formatText(grandTotal - details?.totalAmountPaid,2)}}</span>
        </div>
        <div class="d-flex align-items-center justify-content-center w-100 mt-3" *ngIf="isPreferredUser">
          <button class="btn theme-btn" [disabled]="grandTotal - (+this.details?.totalAmountPaid)<=0"
            (click)="openPaymentPopUp()">Add Payment</button>
        </div>
      </div>
    </div>
    <ng-template #noDataFound>
      <div class="no-data">No Work Order Found.</div>
    </ng-template>
  </div>
</div>
